import { t } from "i18next";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface PasswordVisibilityAdornmentProps {
  visible: boolean;
  onToggle: () => void;
}

export function PasswordVisibilityAdornment({
  visible,
  onToggle,
}: PasswordVisibilityAdornmentProps): JSX.Element {
  return (
    <InputAdornment position="end">
      <IconButton
        type="button"
        aria-label={t("Toggle password visibility")}
        onClick={onToggle}
        onMouseDown={(e) => e.preventDefault()}
        edge="end"
      >
        {visible ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  );
}
